import React, { useCallback, useMemo } from 'react';
import { Grid } from '@nextiva/next-ui-components';

import { LocationActions } from '../locationActions';

export const LocationRow = ({
  locationItem,
  style = {},
  editAction,
  deleteAction,
  voiceAction,
  centerAction,
  isVoiceAccount,
  callCenterLicense,
}) => {
  const formatLongTextValue = useCallback((value, maxLen) => {
    if (value.length > maxLen) {
      return `${value.substring(0, maxLen)}...`;
    }

    return value;
  });

  const formatPhoneNumber = (phoneNumberString) => {
    const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }

    return null;
  };

  const renderedPhoneNumber = useMemo(
    () => formatPhoneNumber(locationItem.outgoingPhoneNumber),
    [locationItem],
  );

  const address = `${locationItem.streetNumber || ''} ${
    locationItem.streetName || ''
  } ${locationItem.streetType || ''}, ${locationItem.city} ${
    locationItem.state || ''
  }, ${locationItem.zip} ${locationItem.country}`;

  return (
    <Grid style={style}>
      <Grid
        container
        alignItems="center"
        className="Body m-table-row"
        data-testid="PlatformAdminUI-Locations-LocationRow-TableRow"
      >
        <Grid item xs={2}>
          <div
            className="m-table-row__data"
            data-testid="PlatformAdminUI-Locations-LocationRow-Name"
          >
            {formatLongTextValue(locationItem.locationName, 15)}{' '}
          </div>
        </Grid>
        <Grid item xs={4}>
          <div
            className="m-table-row__data"
            data-testid="PlatformAdminUI-Locations-LocationRow-Name"
          >
            {address}
          </div>
        </Grid>
        <Grid item xs={1}>
          <div
            className="m-table-row__data"
            data-testid="PlatformAdminUI-Locations-LocationRow-UserCount"
          >
            {locationItem.userCount}
          </div>
        </Grid>
        <Grid item xs={2}>
          <div
            className="m-table-row__data"
            data-testid="PlatformAdminUI-Locations-LocationRow-OutgoingNumber"
          >
            {renderedPhoneNumber}
          </div>
        </Grid>
        <Grid item xs={3}>
          <Grid container alignItems="center">
            <Grid item xs={8}>
              <div
                className="m-table-row__data"
                data-testid="PlatformAdminUI-Locations-LocationRow-CallerID"
              >
                {locationItem.callerId}
              </div>
            </Grid>
            {/* Display the action selector */}
            <Grid item xs={4}>
              <div
                className="actionBase--selector"
                data-testid="PlatformAdminUI-Locations-LocationRow-ActionsButton"
              >
                <LocationActions
                  voiceAction={voiceAction}
                  editAction={editAction}
                  deleteAction={deleteAction}
                  location={locationItem}
                  centerAction={centerAction}
                  isVoiceAccount={isVoiceAccount}
                  callCenterLicense={callCenterLicense}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
